<module-container>
  <div class="title-container">
    <h2>List of Master Products</h2>
  </div>
  <app-master-product-table></app-master-product-table>
</module-container>
